import { Countries } from "@foundation-tool/ui/types";
import type { QuestionGroups } from "../types";
import { Questions } from "../types";

export const PATHS = {
  base: "/bases",
  powder: "/polvos",
  home: "/:countryIso",
  questionary: {
    questions: "/:group/:question",
    tonality: {
      1: "/:group/primer-tono",
      2: "/:group/segundo-tono",
      3: "/:group/tercer-tono",
    },
  },
  profile: {
    index: "/perfil",
    consultant: "/perfil/contacto-consultora",
    client: "/perfil/contacto-cliente",
  },
  recommendations: "/resultados",
};

export const getQueryString = () =>
  (typeof window !== "undefined" && window.location.search) || "";

export const getQuestionaryUrlBuilder = (
  group: QuestionGroups,
  question: Questions,
  iteration?: number,
) => {
  let url = PATHS.questionary.questions
    .replace(":group", group)
    .replace(":question", question);

  if ([Questions.Question3, Questions.Question5].includes(question)) {
    url = `/${group}`;
  }
  if (
    Questions.Question4 === question &&
    iteration &&
    iteration >= 1 &&
    iteration <= 3
  ) {
    url = ((PATHS.questionary.tonality as any)[iteration] || "").replace(
      ":group",
      group,
    );
  }

  return url;
};

export const sanitizeUrl = (countryIso: Countries, url: string) => {
  const urlString = url.replace(":countryIso", countryIso);
  const regex = new RegExp("^\\/" + countryIso + "(?:\\/|$)");
  const startsWithCountry = regex.test(urlString);
  return startsWithCountry
    ? `${urlString}${getQueryString()}`
    : `/${countryIso}${urlString}${getQueryString()}`;
};
